import React from "react";
import { Button, TextField, IconButton } from "@material-ui/core";
import { FieldArray, Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Add, Delete } from "@material-ui/icons";
import {
    DialogActions,
    DialogContent,
    Divider,
    Grid,
} from "@material-ui/core";
import DialogTitle from "./dialog-title";

const FAQForm = (props) => {
    const {
        initValue = [],
        handleSubmit = () => {},
        close = () => {},
    } = props;

    return (
        <>
            <DialogTitle onClose={close}>
                سئوالات متداول
            </DialogTitle>
            <Divider />
            <Formik
                initialValues={{
                    faqs: initValue || [{ question: "", answer: ""}],
                }}
                validationSchema={Yup.object({
                    faqs: Yup.array().of(
                        Yup.object({
                            question: Yup.string().required("سؤال الزامی است"),
                            answer: Yup.string().required("پاسخ الزامی است"),
                        })
                    ),
                })}
                onSubmit={(values, { resetForm }) => {
                    handleSubmit(values)
                }}
            >{({ values, errors, touched, handleChange }) => (
                <Form>
                    <DialogContent className="p-1" style={{ overflowX: "hidden" }}>
                        <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-2xl shadow">
                            <FieldArray name="faqs">
                                {({ push, remove }) => (
                                    <div className="space-y-6">
                                        {values.faqs.map((faq, index) => (
                                            <div>
                                                <div
                                                    key={index}
                                                    className="p-1 border border-gray-200 rounded-xl shadow-sm relative d-flex m-1"
                                                    style={{
                                                        background: "#d3d3d345",
                                                        borderRadius: "10px"
                                                    }}
                                                >
                                                    <div className="flex flex-col space-y-4" style={{ width: "100%" }}>
                                                        <TextField
                                                            fullWidth
                                                            label="سؤال"
                                                            className="mb-2"
                                                            name={`faqs[${index}].question`}
                                                            variant="outlined"
                                                            value={faq.question}
                                                            onChange={handleChange}
                                                            error={
                                                                touched.faqs?.[index]?.question &&
                                                                Boolean(errors.faqs?.[index]?.question)
                                                            }
                                                            helperText={
                                                                touched.faqs?.[index]?.question &&
                                                                errors.faqs?.[index]?.question
                                                            }
                                                        />

                                                        <TextField
                                                            fullWidth
                                                            multiline
                                                            rows={3}
                                                            label="پاسخ"
                                                            name={`faqs[${index}].answer`}
                                                            variant="outlined"
                                                            value={faq.answer}
                                                            onChange={handleChange}
                                                            error={
                                                                touched.faqs?.[index]?.answer &&
                                                                Boolean(errors.faqs?.[index]?.answer)
                                                            }
                                                            helperText={
                                                                touched.faqs?.[index]?.answer &&
                                                                errors.faqs?.[index]?.answer
                                                            }
                                                        />
                                                    </div>

                                                    {values.faqs.length > 1 && (
                                                        <IconButton
                                                            className="absolute top-3 right-3 text-red-500"
                                                            onClick={() => remove(index)}
                                                        >
                                                            <Delete />
                                                        </IconButton>
                                                    )}
                                                </div>
                                                <Divider />
                                            </div>
                                        ))}

                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color="primary"
                                            startIcon={<Add />}
                                            onClick={() => push({ question: "", answer: "" })}
                                            className="mt-2"
                                        >
                                            افزودن سؤال جدید
                                        </Button>
                                    </div>
                                )}
                            </FieldArray>
                        </div>
                    </DialogContent>
                    <Divider />
                    <DialogActions>
                        <div className="mt-8 flex justify-end">
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="px-6 py-2"
                            >
                                ذخیره F&Q‌ها
                            </Button>
                        </div>
                    </DialogActions>
                </Form>
            )}
            </Formik>

        </>
    );
};

export default FAQForm;